import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.css']
})
export class PasswordRecoveryComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
